import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "vr-simulation" }
const _hoisted_2 = { class: "yycj" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-title" }
const _hoisted_5 = { class: "sljs" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "address-list" }
const _hoisted_8 = { class: "address-text" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import { modelTypes } from '@/config';
import { exampleDatas } from '@/config/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'VirtualMuseum',
  setup(__props) {

const loadUrl: any = ref({})
const store = useStore()
const router = useRouter()
const casesList: any = ref({})
const loaderGif: any = ref([]);
const yycjData = [
  {
    title: '博物馆',
    url: require('@/assets/images/ar-images/bwg.png')
  },
  {
    title: '艺术馆',
    url: require('@/assets/images/ar-images/ysg.png')
  },
  {
    title: '科技馆',
    url: require('@/assets/images/ar-images/kjg.png')
  },
  {
    title: '历史馆',
    url: require('@/assets/images/ar-images/lsg.png')
  },
  {
    title: '校史馆',
    url: require('@/assets/images/ar-images/xsg.png')
  },
  {
    title: '成果展',
    url: require('@/assets/images/ar-images/cgz.png')
  }
]

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesList.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0))[0] || {}
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const bwgjs: any = await asynchronousRetrieval('webimg/gif/bwgjs.gif');
  const bwgsd: any = await asynchronousRetrieval('webimg/gif/bwgsd.gif');
  const bwgbj: any = await asynchronousRetrieval('webimg/gif/bwgbj.gif');
  const bwgzj: any = await asynchronousRetrieval('webimg/gif/bwgzj.gif');
  loadUrl.value = { fays_bg }
  loaderGif.value.push(bwgjs, bwgsd, bwgbj, bwgzj);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-text" }, "应用场景", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yycjData, (item, index) => {
        return _createElementVNode("div", { key: index }, [
          _createElementVNode("img", {
            src: item.url
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1)
        ])
      }), 64))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-text" }, "实例介绍", -1)),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exampleDatas).xnbwg.example, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("img", {
            src: loaderGif.value[index]
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.address), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})